(function () {
  document.querySelectorAll("[data-professionals-app]").forEach(init);

  function init(root) {
    const appUrl = String(root.dataset.appUrl || "").replace(/\/$/, "");
    const tokenKey = "forumProfessionalToken";
    let token = localStorage.getItem(tokenKey) || "";
    const login = root.querySelector("[data-pro-login]");
    const workspace = root.querySelector("[data-pro-workspace]");
    const questionsRoot = root.querySelector("[data-pro-questions]");
    const identity = root.querySelector("[data-pro-identity]");
    const filter = root.querySelector("[data-pro-filter]");

    async function api(path, options) {
      const response = await fetch(`${appUrl}${path}`, {
        ...(options || {}),
        headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || "Errore durante la richiesta.");
      return data;
    }

    login.addEventListener("submit", async (event) => {
      event.preventDefault();
      const error = login.querySelector("[data-pro-error]");
      const button = login.querySelector("button[type='submit']");
      const originalLabel = button.textContent;
      error.textContent = "";
      button.disabled = true;
      button.textContent = "Accesso in corso...";
      try {
        const data = await api("/api/professionals/login", { method: "POST", body: JSON.stringify({ email: login.email.value, password: login.password.value }) });
        token = data.token;
        localStorage.setItem(tokenKey, token);
        showWorkspace(data.user);
        await loadQuestions();
      } catch (err) { error.textContent = err.message; }
      finally { button.disabled = false; button.textContent = originalLabel; }
    });

    root.querySelector("[data-pro-logout]").addEventListener("click", async () => {
      try { await api("/api/professionals/logout", { method: "POST" }); } catch (_) {}
      clearSession();
    });
    filter.addEventListener("change", loadQuestions);

    function showWorkspace(user) {
      login.closest("[data-pro-login-panel]").classList.add("is-hidden");
      workspace.classList.remove("is-hidden");
      identity.textContent = `${user.firstName || ""} ${user.lastName || ""} · ${user.email || ""}`;
    }

    function clearSession() {
      token = "";
      localStorage.removeItem(tokenKey);
      workspace.classList.add("is-hidden");
      login.closest("[data-pro-login-panel]").classList.remove("is-hidden");
    }

    async function loadQuestions() {
      const suffix = filter.value ? `?status=${encodeURIComponent(filter.value)}` : "";
      const questions = await api(`/api/professionals/questions${suffix}`);
      questionsRoot.innerHTML = questions.length ? questions.map(renderQuestion).join("") : '<div class="forum-professionals__card">Nessuna domanda da mostrare.</div>';
      questionsRoot.querySelectorAll("form[data-question-id]").forEach((form) => form.addEventListener("submit", answer));
    }

    function renderQuestion(question) {
      const answers = (question.answers || []).map((answer) => `<div class="forum-professionals__answer"><strong>${escapeHtml(answer.authorName || "Staff")}</strong><div>${escapeHtml(answer.body)}</div></div>`).join("");
      const author = firstName(question.authorName || question.customerName) || "Anonimo";
      return `<article class="forum-professionals__card"><div class="forum-professionals__meta">${escapeHtml(question.categoryName || "")} · ${formatDate(question.originalQuestionDate || question.createdAt)} · ${escapeHtml(question.status)}</div><h2>${escapeHtml(question.title)}</h2><div class="forum-professionals__body">${escapeHtml(question.body)}</div><p class="forum-professionals__author"><strong>Domanda posta da:</strong> ${escapeHtml(author)}</p>${answers}<form class="forum-professionals__stack" data-question-id="${escapeHtml(question.id)}"><label>La tua risposta<textarea required minlength="3"></textarea></label><button type="submit">Rispondi e pubblica</button><p class="forum-professionals__error" data-pro-error></p></form></article>`;
    }

    async function answer(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector("button");
      button.disabled = true;
      try {
        await api(`/api/professionals/questions/${encodeURIComponent(form.dataset.questionId)}/answers`, { method: "POST", body: JSON.stringify({ body: form.querySelector("textarea").value }) });
        await loadQuestions();
      } catch (err) { form.querySelector("[data-pro-error]").textContent = err.message; button.disabled = false; }
    }

    function escapeHtml(value) { return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;"); }
    function firstName(value) { return String(value || "").trim().split(/\s+/)[0] || ""; }
    function formatDate(value) { const date = new Date(value); return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("it-IT"); }

    if (token) api("/api/professionals/me").then((data) => { showWorkspace(data.user); loadQuestions(); }).catch(clearSession);
  }
})();
